"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const constants_1 = require("./constants");
const ModalProvider = ({ children, value = [] }) => {
    if (!value.length)
        console.error(constants_1.ERROR_MESSAGES.MODAL_PROVIDER_EMPTY_VALUE);
    return value.reduce((acc, curr) => (0, react_1.createElement)(curr, null, acc), children);
};
exports.default = ModalProvider;
